import { useMemo } from 'react';
import { useGlobalState } from 'src/stateProviders/GlobalStateProvider';
import { useQuoteState } from 'src/stateProviders/QuoteStateProvider';

const useIsBetaCanvasEnabled = () => {
	const { company } = useGlobalState();
	const { currentQuote } = useQuoteState();

	return useMemo(() => {
		if (!company?.betaCanvasEnabled) return false;
		if (!currentQuote?.createdAt) return false;

		const betaCanvas = Boolean(
			!currentQuote.blocks.length ||
			currentQuote.blocks[0].edges[0].segments?.length
		);

		return betaCanvas;
	}, [company, currentQuote]);
};

export default useIsBetaCanvasEnabled;
